export default __webpack_public_path__ + "static/media/D04.fd606920.png";